module.exports = __webpack_public_path__ + "media/images/icons/command-4365cdce263d2e0d3e34cb616c01b34f.svg";